<script>
import InputWebsiteVue from "../../components/shared/InputWebsite.vue";
import ChatBotDemoMessage from "./AnimationMessage.vue";

const CHAT_PREVIEW_PADDING = 35;
const CHAT_PREVIEW_WIDTH = 400;

export default {
    data() {
        return {
            isLoading: false,
            isOpen: true,
            messages: [],
            timerId: null,
            animationStep: 0,
            showWelcome: false,
            showAnimation: false,
        };
    },
    components: {
        InputWebsiteVue,
        ChatBotDemoMessage,
    },
    name: "ChatBotAnimation",
    mounted() {
        setTimeout(() => {
            this.showAnimation = true;
        }, 300);

        this.timerId = setInterval(this.sendMessage, 2000);
    },
    methods: {
        async sendMessage() {
            if (this.messages.length >= 6) {
                this.messages = [];
                this.animationStep = 0;
                this.showWelcome = false;
                return;
            }

            if (this.animationStep === 0) {
                this.showWelcome = true;
                this.animationStep += 1;
                return;
            }

            if (this.animationStep === 1) {
                this.handleQuestion("Hi! I want to watch something interesting tonight. Any suggestions?");
                return;
            }

            if (this.animationStep === 2) {
                this.handleAnswer("Hello! What movie genre are you most interested in?");
                return;
            }

            if (this.animationStep === 3) {
                this.handleQuestion("I'm thinking about something in the adventure or science fiction genre.");
                return;
            }

            if (this.animationStep === 4) {
                this.handleAnswer("In that case, I can recommend the movie 'Blue Beetle'. It's an exciting science fiction adventure with great reviews.");
                return;
            }

            if (this.animationStep === 5) {
                this.handleQuestion("Yes, that sounds good. Please provide me with a link to watch it.");
                return;
            }

            if (this.animationStep === 6) {
                this.handleAnswer("Here is <a style='color: #0165FF;'>the link</a>. Enjoy the movie!");
                return;
            }
        },
        handleAnswer(answer) {
            const answerData = { answer };
            this.messages.splice(this.messages.length, 0, answerData);
            this.animationStep += 1;
        },
        handleQuestion(question) {
            const questionData = { question };
            this.messages.splice(this.messages.length, 0, questionData);
            this.animationStep += 1;
        },
    },
    computed: {
        previewStyles() {
            return {
                padding: `${CHAT_PREVIEW_PADDING}px`,
                width: `${CHAT_PREVIEW_WIDTH + CHAT_PREVIEW_PADDING * 2}px`,
            };
        },

        chatbotBoxStyle() {
            return {
                height: '573px',
                width: '340px',
                fontSize: '14px',
            };
        },

        botIconBoxStyle() {
            return {
                height: "48px",
                width: "48px",
            };
        },

        thumbUpUrl() {
            return require("@/assets/icons/ThumbUp.svg");
        },

        sendUrl() {
            return require("@/assets/img/send_bot.svg");
        },

        botIcon() {
            return require("@/assets/icons/ai-icon.svg");
        },

        agentIcon() {
            return require("@/assets/img/bot_icon_online.svg");
        },

        userIcon() {
            return null;
        },
    },
    watch: {
        messages: {
            handler() {
                const container = this.$el.querySelector("#messagesCard");
                const scrollOptions = { top: container.scrollHeight + 20, behavior: 'smooth' };

                this.$nextTick(() => {
                    window.requestAnimationFrame(() => container.scrollTo(scrollOptions));
                });
                setTimeout(() => {
                    window.requestAnimationFrame(() => container.scrollTo(scrollOptions));
                }, 1500);
            },
            deep: true,
        },
    },
    beforeDestroy() {
        clearInterval(this.timerId);
    },
};
</script>

<template>
    <div>
        <Transition name="fade">
            <div v-show="showAnimation" class="box boxOpen">
                <div class="chatbot_preview open" :style="chatbotBoxStyle">
                    <div class="chatbot_preview__heder" :style="{ background: '#fff' }">
                        <div class="chatbot_preview__title-box position-relative">
                            <div v-if="agentIcon" class="chatbot_preview__bot-icon-box">
                                <img :src="agentIcon" alt="" />
                            </div>
                            <div>
                                <p class="chatbot_preview__title">ChatBot</p>
                                <p class="chatbot_preview__sub-title">Online</p>
                            </div>
                        </div>
                        <img src="@/assets/img/Close_round.svg" alt="" class="position-absolute close_icon" />
                    </div>

                    <div class="chatbot_preview__chat" :style="{ maxHeight: `550px` }" id="messagesCard">
                        <div class="chatbot_preview__messages-box">
                            <ul class="chatbot_preview__messages-list">
                                <Transition name="list">
                                    <div v-if="showWelcome">
                                        <ChatBotDemoMessage :icons="{ agentIcon: agentIcon }" :message="{
                                            answer: 'Welcome. How can I assist you?',
                                            aCreatedAt: Date.now(),
                                        }" :showLoader="false" />
                                        <div v-if="messages.length === 0" class="btns_list">
                                            <div class="btns_list--item">Using ChatBot 👉</div>
                                            <div class="btns_list--item">I have questions 🙂</div>
                                            <div class="btns_list--item">I have questions 👀</div>
                                        </div>

                                    </div>

                                </Transition>
                                <transition-group name="list" tag="li" appear>
                                    <li v-for="(item, i) of messages" :key="i + item?.answer || item?.question"
                                        class="list-item">
                                        <ChatBotDemoMessage :icons="{ agentIcon: agentIcon, userIcon: userIcon }"
                                            :message="item" :showLoader="true" class="mb-2" />
                                    </li>
                                </transition-group>
                            </ul>
                        </div>
                    </div>

                    <form @submit.prevent="sendMessage" class="chatbot_preview__footer">
                        <div class="chatbot_preview__footer--content">
                            <input ref="message" type="text" placeholder="Type something here..." disabled
                                class="chatbot_preview__input" />
                            <button type="submit" :disabled="true" class="chatbot_preview__send-btn">
                                <img :src="sendUrl" />
                            </button>

                        </div>
                        <div class="chatbot_preview__footer--powered">Powered by <span>ChatBot</span></div>
                    </form>
                </div>
            </div>
        </Transition>
    </div>
</template>

<style scoped lang="scss">
.list-item {
    transition: all 0.5s ease;
}

.list-enter-active,
.list-leave-active {
    transition: opacity 0.5s, transform 0.5s ease;
}

.list-enter,
.list-leave-to {
    opacity: 0;
    transform: translateY(30px);
}

.box {
    width: 100%;
    height: 100%;
    font-family: Inter;
}

.chatbot_preview__bot-icon-button {
    padding: 0;
    z-index: 100;
    font: inherit;
    color: inherit;
    background: transparent;
    cursor: pointer;
    text-align: center;
    border-radius: 50%;
    border: none;

    transition: all 150ms linear;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    &>div {
        display: flex;
        align-items: center;
        justify-content: center;

        &>img {
            width: 100%;
            height: 100%;
        }
    }

    &:hover {
        transform: scale(1.02);
    }
}

.chatbot_preview__title {
    color: #000;
    font-size: 24px;
    font-weight: 700;
    margin: 0;
    padding: 0;
}

.chatbot_preview__sub-title {
    font-family: inherit;
    color: #828282;
    font-size: 16px;
    margin: 0;
    padding: 0;
}

.chatbot_preview {
    border-radius: 24px;
    border: 1px solid #EAEDF4;
    background: #fff;
    overflow: hidden;
    object-fit: cover;
    display: flex;
    flex-direction: column;
    transform: translate(50%, 50%) scale(0);
    transition: all 200ms linear;

    &.left {
        transform: translate(-50%, 50%) scale(0);
    }

    &.open {
        transform: translate(0, 0) scale(1);
    }
}

.chatbot_preview__heder {
    padding: 20px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
}

.close_icon {
    top: 16px;
    right: 16px;
}

.chatbot_preview__title-box {
    display: flex;
    align-items: center;
    gap: 20px;
}

.chatbot_preview__thumbUp-box {
    display: flex;
    gap: 25px;
}

.chatbot_preview__bot-icon-box {
    overflow: hidden;
    position: relative;
    object-fit: cover;
    height: 65px;
    width: 65px;
    display: flex;
    justify-content: center;
    align-items: center;

    &>img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
}

.chatbot_preview__thumbUp {
    object-fit: cover;
    padding: 0;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    fill: #fff;

    & svg {
        width: 16px;
        height: 16px;
        fill: inherit;
    }

    &--rotate180 {
        & svg {
            transform: rotate(180deg);
        }
    }
}

.chatbot_preview__chat {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: hidden;
    background: #EAEDF4;
}

.chatbot_preview__messages-box {
    flex-grow: 1;
    margin-bottom: 20px;

}

.chatbot_preview__messages-list {
    list-style: none;
    padding: 0 20px 0 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 20px !important;
}

.chatbot_preview__action-box {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 24px;
}

.chatbot_preview__action {
    padding: 4px 8px;
    font: inherit;
    color: inherit;
    background-color: transparent;
    cursor: pointer;
    text-align: center;
    font-size: 0.78em;
    font-weight: 500;
    line-height: 1.71;
    border-radius: 6px;
    border-width: 1px;
    border-style: solid;
    display: inline-block;
    transition: all ease-in-out 300ms;
}

.chatbot_preview__footer {
    width: 100%;
    display: flex;
    flex-direction: column;

    &--content {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    &--powered {
        display: flex;
        justify-content: center;
        gap: 3px;
        padding: 10px 0px;
        border-top: 1px solid #EDEDED;
        background: #F9F9F9;
        color: #828282;
        font-size: 10px;
        font-weight: 700;

        span {
            color: #0165FF;
        }
    }
}

.chatbot_preview__send-btn {
    font: inherit;
    color: inherit;
    cursor: pointer;
    color: #fff;
    fill: #fff;
    text-align: center;
    border-radius: 6px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 150ms linear;
    width: 52px;
    height: 52px;
    background: #fff;
    margin-right: 10px;

    &:disabled {
        pointer-events: none;
        cursor: default;
    }
}

.chatbot_preview__input {
    width: 100%;
    height: 51px;
    border: none;
    background: #fff;
    padding: 14px 20px;
    position: relative;
}

.btns_list {
    margin: 16px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;

    &--item {
        color: #0165FF;
        font-size: 16px;
        font-weight: 700;
        line-height: 18px;
        padding: 12px 20px;
        border-radius: 24px;
        border: 1px solid #0165FF;
        width: fit-content;
    }
}
</style>
